package com.evoapps.evoshift.data.dto.staff

import kotlinx.serialization.Serializable

/**
 * users/{uid}/hr/{wpId} (SH-47): dates only, "YYYY-MM-DD". Never results, restrictions or scans
 * (firestore.rules allows only these fields).
 */
@Serializable
data class StaffHrDto(
    val userId: String = "",
    val workplaceId: String = "",
    val medicalExam: MedicalExamDto? = null,
    val ohsTraining: OhsTrainingDto? = null,
    val updatedAt: String? = null,
    val updatedBy: String? = null,
    /** SH-212: the earlier (or planned) trainings and exams, at most 10; absent in older documents. */
    val history: List<StaffCheckDto> = emptyList()
)

/** SH-212: [examinedOn] the day of the exam, when known (older documents: the validity only). */
@Serializable
data class MedicalExamDto(val validUntil: String? = null, val examinedOn: String? = null)

/** SH-212: one training or exam of the history: [check] MEDICAL_EXAM or OHS_TRAINING, its day and validity. */
@Serializable
data class StaffCheckDto(val check: String = "", val from: String? = null, val validUntil: String? = null)

@Serializable
data class OhsTrainingDto(val completedOn: String? = null, val validUntil: String? = null)

/** workplaces/{wpId}/readiness/{uid}: the statuses operational managers read (no dates). */
@Serializable
data class StaffReadinessDto(
    val userId: String = "",
    val workplaceId: String = "",
    val medical: String = "MISSING",
    val ohs: String = "MISSING",
    val checkedOn: String? = null
)

/** workplaces/{wpId}/staff_notes/{uid}: availability notes the managers schedule by. */
@Serializable
data class StaffNotesDto(
    val userId: String = "",
    val notes: String = "",
    val updatedAt: String? = null,
    val updatedBy: String? = null
)
